import { useQuery, useMutation, useQueryClient } from 'react-query';
import { deleteContract, getContract } from 'lib/api/contract';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setOriginalContract } from 'modules/contractSlice';
import useLoginCheck from 'hooks/common/useLoginCheck';

const useContractViewer = id => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const { isLoading, error, data, refetch } = useQuery(['contract', id], () =>
    getContract(id),
  );
  useLoginCheck(error?.response, refetch);
  const contract = data?.data.contract;
  const master = data?.data.master;
  const masterKids = data?.data.masterKids;

  const deleteContractMutation = useMutation(deleteContract, {
    onSuccess: () => {
      queryClient.invalidateQueries('dashboardCounts');
      navigate('/admin/contracts');
    },
  });
  useLoginCheck(deleteContractMutation.error?.response, () => {
    deleteContractMutation.mutate(id);
  });

  const onEdit = () => {
    dispatch(setOriginalContract({ contract, master }));
    navigate('/admin/contracts/editor');
  };

  const onDelete = () => {
    deleteContractMutation.mutate(id);
  };

  return {
    isLoading,
    error,
    contract,
    master,
    masterKids,
    deleteContractMutation,
    onEdit,
    onDelete,
  };
};

export default useContractViewer;
